import _assertThisInitialized from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import './iPadShowKeyboard.css';
import * as browser from '../../../../base/browser/browser.js';
import * as dom from '../../../../base/browser/dom.js';
import { Disposable } from '../../../../base/common/lifecycle.js';
import { registerEditorContribution } from '../../../browser/editorExtensions.js';
export var IPadShowKeyboard = /*#__PURE__*/function (_Disposable) {
  _inherits(IPadShowKeyboard, _Disposable);

  var _super = _createSuper(IPadShowKeyboard);

  function IPadShowKeyboard(editor) {
    var _this;

    _classCallCheck(this, IPadShowKeyboard);

    _this = _super.call(this);
    _this.editor = editor;
    _this.widget = null;

    if (browser.isIPad) {
      _this._register(editor.onDidChangeConfiguration(function () {
        return _this.update();
      }));

      _this.update();
    }

    return _this;
  }

  _createClass(IPadShowKeyboard, [{
    key: "update",
    value: function update() {
      var shouldHaveWidget = !this.editor.getOption(72
      /* readOnly */
      );

      if (!this.widget && shouldHaveWidget) {
        this.widget = new ShowKeyboardWidget(this.editor);
      } else if (this.widget && !shouldHaveWidget) {
        this.widget.dispose();
        this.widget = null;
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(IPadShowKeyboard.prototype), "dispose", this).call(this);

      if (this.widget) {
        this.widget.dispose();
        this.widget = null;
      }
    }
  }]);

  return IPadShowKeyboard;
}(Disposable);
IPadShowKeyboard.ID = 'editor.contrib.iPadShowKeyboard';

var ShowKeyboardWidget = /*#__PURE__*/function (_Disposable2) {
  _inherits(ShowKeyboardWidget, _Disposable2);

  var _super2 = _createSuper(ShowKeyboardWidget);

  function ShowKeyboardWidget(editor) {
    var _this2;

    _classCallCheck(this, ShowKeyboardWidget);

    _this2 = _super2.call(this);
    _this2.editor = editor;
    _this2._domNode = document.createElement('textarea');
    _this2._domNode.className = 'iPadShowKeyboard';

    _this2._register(dom.addDisposableListener(_this2._domNode, 'touchstart', function (e) {
      _this2.editor.focus();
    }));

    _this2._register(dom.addDisposableListener(_this2._domNode, 'focus', function (e) {
      _this2.editor.focus();
    }));

    _this2.editor.addOverlayWidget(_assertThisInitialized(_this2));

    return _this2;
  }

  _createClass(ShowKeyboardWidget, [{
    key: "dispose",
    value: function dispose() {
      this.editor.removeOverlayWidget(this);

      _get(_getPrototypeOf(ShowKeyboardWidget.prototype), "dispose", this).call(this);
    } // ----- IOverlayWidget API

  }, {
    key: "getId",
    value: function getId() {
      return ShowKeyboardWidget.ID;
    }
  }, {
    key: "getDomNode",
    value: function getDomNode() {
      return this._domNode;
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      return {
        preference: 1
        /* BOTTOM_RIGHT_CORNER */

      };
    }
  }]);

  return ShowKeyboardWidget;
}(Disposable);

ShowKeyboardWidget.ID = 'editor.contrib.ShowKeyboardWidget';
registerEditorContribution(IPadShowKeyboard.ID, IPadShowKeyboard);